module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('c-view', [_c('c-page', [_c('c-content', [_c('div', {
    staticClass: "protocol-container"
  }, [_c('div', {
    staticClass: "protocol-title text-center"
  }, [_vm._v("生意专家服务说明")]), _vm._v(" "), _c('div', {
    staticClass: "protocol-text"
  }, [_c('div', {
    staticClass: "mt-20"
  }, [_vm._v("\n            生意专家提供的“行业版”服务，主要针对实体店的店铺管理。开通这项服务后，您可以拥有各类高效的工具，解决收银记账、会员管理、进销存等核心业务里的问题。\n          ")]), _vm._v(" "), _c('div', {
    staticClass: "mt-10"
  }, [_vm._v("\n            在您购买完成后，服务即自动生效。但如果您有需要，我们可以为您寄送精美的“行业版”实体硬件，我们的服务是以实体卡的形势售卖的。\n          ")]), _vm._v(" "), _c('div', {
    staticClass: "mt-10"
  }, [_vm._v("\n            我们还提供上门咨询服务及远程服务，您在使用过程中，有任何问题，随时联系我们。您可以在生意专家公众号里，联系我们的客服或拨打电话: "), _c('a', {
    staticClass: "text-color orange font-bold",
    attrs: {
      "href": "tel:021-56380166"
    }
  }, [_vm._v("021-56380166")])]), _vm._v(" "), _c('div', {
    staticClass: "mt-10"
  }, [_vm._v("\n            最终解释权归生意专家所有。\n          ")])])])])], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-6ea62a54","hasScoped":true}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/about-me/service-protocol/index.vue
// module id = 1059
// module chunks = 2